'use strict';

import { Component } from 'react';
import { Tabs } from '@ux/uxcore2';

const { TabIndex, Tab } = Tabs;


export default class AppTab extends Component {

  constructor(props) {
    super(props);

    this.state = {
      selected: 0
    };
  }

  change(index, event) {
    event.preventDefault();

    this.setState({
      selected: index
    });
  }

  syncContent() {
    var items = $(this.props.selector);
    items.removeClass('active');
    items.eq(this.state.selected).addClass('active');
  }

  componentDidMount() {
    this.syncContent();
  }

  componentDidUpdate() {
    this.syncContent();
  }

  render() {
    return (
      <section>
        <Tabs change={this.change.bind(this)} selected={this.state.selected}>
          <TabIndex>
          {
            this.props.tabNames.map((tabName, key) => (
              <Tab key={key}>{tabName}</Tab>
            ))
          }
          </TabIndex>
        </Tabs>
      </section>
    );
  }
}
